import React from "react";

import { DefaultLayout } from "@components/Layouts";
import AccessServer from "@screens/GameCenter/AccessServer";
import NotFound from "@screens/NotFound";

export default function GameCenterScreen({ screen }) {
    let body = "";
    switch (screen) {
        case "access_test_astrum":
        case "access_admin":
            body = <AccessServer screen={screen} />;
            break;
        default:
            break;
    }

    if (!body) {
        return <NotFound />;
    }

    return <DefaultLayout>{body}</DefaultLayout>;
}
